export function imageProxyUrl(url, width, format = 'jpg') {
  if (!url) {
    return ''
  }
  const protocoll = url.match(/^\/\//) ? 'https:' : ''
  const source = escape(protocoll + url)
  return `https://imageproxy.a2d.tv/?format=${format}&width=${width}&source=${source}`
}
